

<div class="row align-items-center" style="border-bottom: 1px solid #5d2041; margin-top: 1px solid #5d2041; height:68.6px">
  <div class="col">
    <div class="eventsheader">My Calendar</div>
  </div>
  
</div>


<body style="background-color: rgb(241, 235, 228);">
<div class="togglegroup">
<mat-button-toggle-group #group="matButtonToggleGroup" name="fontStyle" aria-label="Font Style" [(value)]="toggle" (change)="OnToggleChanged(group.value)">
  <mat-button-toggle id="calendarbutton" value="calendar" class="calendarview" (click)="calendarView()"><mat-icon class="material-icons toggleicon">
    event
  </mat-icon>
</mat-button-toggle>
  <mat-button-toggle value="list" class="listview" (click)="listView()"><mat-icon class="material-icons toggleicon">
    list
  </mat-icon>
</mat-button-toggle>
</mat-button-toggle-group>
</div>

 

<!-- https://fullcalendar.io/docs -->

<div class="calendar">
<full-calendar  *ngIf="toggle == 'calendar'"  id="calendarview" [options]="calendarViewOptions"></full-calendar>

<full-calendar *ngIf="toggle == 'list'" id="listview" [options]="calendarListOptions"></full-calendar>
</div>


